import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { IPaginationInfo } from './types';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';

interface IVideoManagementPaginationProps {
    pagination: IPaginationInfo;
    onPageChange: (page: number) => void;
    loading?: boolean;
}

export const VideoManagementPagination: React.FC<IVideoManagementPaginationProps> = ({
    pagination,
    onPageChange,
    loading = false,
}) => {
    const { themeStyle } = useThemeContext();

    const handlePreviousPage = () => {
        if (pagination.hasPreviousPage && !loading) {
            onPageChange(pagination.page - 1);
        }
    };

    const handleNextPage = () => {
        if (pagination.hasNextPage && !loading) {
            onPageChange(pagination.page + 1);
        }
    };

    if (pagination.totalPages <= 1) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 2,
                py: 4,
                borderTop: '1px solid',
                borderColor: 'divider',
            }}>
            <Button
                variant="outlined"
                startIcon={<ChevronLeft sx={{ color: theme[themeStyle].tag_white }} />}
                onClick={handlePreviousPage}
                disabled={!pagination.hasPreviousPage || loading}
                sx={{ minWidth: 120 }}>
                <Typography sx={{ color: theme[themeStyle].tag_white, textTransform: 'capitalize' }}>
                    Previous
                </Typography>
            </Button>

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 3,
                    py: 1,
                    backgroundColor: theme[themeStyle].deep_grey_lighter,
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                }}>
                <Typography variant="body2" sx={{ color: theme[themeStyle].tag_white }}>
                    Page
                </Typography>
                <Typography variant="h6" fontWeight="bold" sx={{ color: theme[themeStyle].tag_white }}>
                    {pagination.page}
                </Typography>
                <Typography variant="body2" sx={{ color: theme[themeStyle].tag_white }}>
                    of {pagination.totalPages}
                </Typography>
            </Box>

            <Button
                variant="outlined"
                endIcon={<ChevronRight sx={{ color: theme[themeStyle].tag_white }} />}
                onClick={handleNextPage}
                disabled={!pagination.hasNextPage || loading}
                sx={{ minWidth: 120 }}>
                <Typography sx={{ color: theme[themeStyle].tag_white, textTransform: 'capitalize' }}>Next</Typography>
            </Button>
        </Box>
    );
};
